export type TypographyProps = React.HTMLAttributes<HTMLElement>;

export const typographyClass = {
  title:
    "scroll-m-20 text-4xl md:text-5xl font-extrabold tracking-tight leading-none",
  subtitle: "scroll-m-20 text-2xl md:text-4xl font-bold tracking-tight",
  smallSubtitle: "scroll-m-20 text-xl md:text-2xl tracking-tight",
  largeBody: "text-lg md:text-xl",
  body: "text-base",
  smallBody: "text-sm",
};
export const Typography = {};
